export const {
  NODE_ENV = 'production',
  REACT_APP_DEPLOY_ENV,
  REACT_APP_DOMAIN_NAME = 'apryl.co',
  REACT_APP_BACKEND_URL,
  REACT_APP_GRAPHCMS_ENDPOINT_URL,
  REACT_APP_HEAP_ANALYTICS_ID,
  REACT_APP_FAQ_SLUG = 'members-faq-eu-v2',
  REACT_APP_CALCOM_EMBED_URL = 'https://calcom.staging.tools.apryl.co/embed/embed.js',
  REACT_APP_CALCOM_ORIGIN = 'https://calcom.staging.tools.apryl.co',
  REACT_APP_CALCOM_ROUTING_FORM_LINK = '',
  REACT_APP_CARD_DOMAIN,
  REACT_APP_CARD_SANDBOX,
  REACT_APP_SENTRY_DSN = '',
} = process.env

if (!REACT_APP_BACKEND_URL || !REACT_APP_GRAPHCMS_ENDPOINT_URL) {
  throw new Error(
    'Missing .env vars. Make sure you created all .env vars. See .env-template'
  )
}

if (!REACT_APP_CALCOM_EMBED_URL || !REACT_APP_CALCOM_ORIGIN) {
  throw new Error(
    'Missing Cal.com .env vars. Make sure REACT_APP_CALCOM_EMBED_URL and REACT_APP_CALCOM_ORIGIN are set.'
  )
}

export const isDevelopment = NODE_ENV === 'development'

export const isTest = NODE_ENV === 'test'

export const isStaging = REACT_APP_DEPLOY_ENV === 'staging'

export const isProduction = NODE_ENV === 'production' && !isStaging
